import { FC, memo } from 'react'
import styled from 'styled-components'

type TraderENSProps = {
	trader: string
	traderShort: string
	shortlist?: boolean
}

const TraderENS: FC<TraderENSProps> = memo(({ traderShort, shortlist }) => {
	return <StyledTrader $shortlist={shortlist}>{traderShort}</StyledTrader>
})

const StyledTrader = styled.a<{ $shortlist?: boolean }>`
	color: ${(props) => props.theme.colors.selectedTheme.newTheme.text.primary};
	display: flex;
	font-size: ${(props) => (props.$shortlist ? 15 : 13)}px;
`

export default TraderENS
